import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Heading } from "../common/Heading/Heading";
import { OrganizationsTable } from "./OrganizationsTable/OrganizationsTable";
import { OrganizationModal } from "./OrganizationModal/OrganizationModal";
import { useTranslation } from "react-i18next";
import { Button } from "../common/Button/Button";
import { useData } from "../../context/DataContext";

export const Organizations = () => {
  const { t } = useTranslation();
  const { organizations, isLoading, error, fetchOrganizations } = useData();
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (!organizations.length) {
      fetchOrganizations(1, 100);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container>
      <ContentWrapper>
        <TitleSection>
          <Heading text={t("organizations.organizations")} size={1} />
          <Button
            text={t("organizations.createOrganization")}
            onClick={() => setIsModalOpen(true)}
            variant="primary"
            disabled={isLoading}
          />
        </TitleSection>

        {error && <ErrorMessage>{error}</ErrorMessage>}

        <OrganizationsTable
          organizations={organizations}
          isLoading={isLoading}
        />

        <OrganizationModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        />
      </ContentWrapper>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
`;

const ContentWrapper = styled.div``;

const TitleSection = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 2rem;
  flex-direction: column;
  gap: 1rem;
`;

const ErrorMessage = styled.div`
  color: #d52566;
  background-color: #fff5f7;
  border: 1px solid #ffc2d1;
  padding: 1rem;
  border-radius: 0.5rem;
  margin-bottom: 1.5rem;
`;
